import { render, staticRenderFns } from "./MultipleChoiceEditOptionSidebar.vue?vue&type=template&id=3c18d80f&scoped=true"
import script from "./MultipleChoiceEditOptionSidebar.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceEditOptionSidebar.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoiceEditOptionSidebar.vue?vue&type=style&index=0&id=3c18d80f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c18d80f",
  null
  
)

export default component.exports